var _path, _path2, _circle, _path3, _circle2, _path4, _circle3, _path5, _circle4, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrightlayerUiConformity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 125,
    viewBox: "0 0 445 125",
    width: 445,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h445v125h-445z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 63h445",
    stroke: "#e0eef8",
    strokeDasharray: "4 6",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 63,
    fill: "#e0eef8",
    r: 40
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m71.5167 66.3333h1.3166l8.3167 8.3334-2.4833 2.4833-8.3334-8.3167v-1.3166l-.45-.4667c-1.9 1.6333-4.3666 2.6167-7.05 2.6167-5.9833 0-10.8333-4.85-10.8333-10.8334 0-5.9833 4.85-10.8333 10.8333-10.8333 5.9834 0 10.8334 4.85 10.8334 10.8333 0 2.6834-.9834 5.15-2.6167 7.05zm-16.1834-7.5c0 4.15 3.35 7.5 7.5 7.5s7.5-3.35 7.5-7.5-3.35-7.5-7.5-7.5-7.5 3.35-7.5 7.5z",
    fill: "#007bc1",
    fillRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 63,
    fill: "#e0eef8",
    r: 40
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m291.667 54.6667v3.3333h-3.334v3.3333h3.334v3.3334h-3.334v3.3333h3.334v3.3333h-3.334v3.3334c0 1.8333-1.5 3.3333-3.333 3.3333h-23.333c-1.834 0-3.334-1.5-3.334-3.3333v-23.3334c0-1.8333 1.5-3.3333 3.334-3.3333h23.333c1.833 0 3.333 1.5 3.333 3.3333v3.3334zm-30 20h23.333v-23.3334h-23.333zm3.333-10h8.333v6.6666h-8.333zm16.667-10h-6.667v5h6.667zm-16.667 0h8.333v8.3333h-8.333zm16.667 6.6666h-6.667v10h6.667z",
    fill: "#007bc1",
    fillRule: "evenodd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 63,
    fill: "#e0eef8",
    r: 40
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m170.2 44.6666v5c7.072 0 12.8 5.9667 12.8 13.3334 0 2.6166-.736 5.05-1.984 7.1l-2.336-2.4334c.72-1.3833 1.12-2.9833 1.12-4.6666 0-5.5167-4.304-10-9.6-10v5l-6.4-6.6667zm-9.6 18.3334c0 5.5166 4.304 10 9.6 10v-5l6.4 6.6666-6.4 6.6667v-5c-7.072 0-12.8-5.9667-12.8-13.3333 0-2.6167.736-5.05 1.984-7.1l2.336 2.4333c-.72 1.3833-1.12 2.9833-1.12 4.6667z",
    fill: "#007bc1",
    fillRule: "evenodd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 379,
    cy: 63,
    fill: "#e0eef8",
    r: 40
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m390.667 48h-1.667v-3.3334h-3.333v3.3334h-13.334v-3.3334h-3.333v3.3334h-1.667c-1.85 0-3.316 1.5-3.316 3.3333l-.017 23.3333c0 1.8334 1.483 3.3334 3.333 3.3334h23.334c1.833 0 3.333-1.5 3.333-3.3334v-23.3333c0-1.8333-1.5-3.3333-3.333-3.3333zm-4.117 13.4333-1.767-1.7667-8.133 8.1334-3.533-3.5334-1.767 1.7667 5.3 5.3zm-19.217 13.2333h23.334v-18.3333h-23.334z",
    fill: "#007bc1",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightlayerUiConformity);
export default __webpack_public_path__ + "static/media/brightlayer-ui-conformity.da1cc05a9e23eeeeb66ec948a9f33f96.svg";
export { ForwardRef as ReactComponent };